import { render, staticRenderFns } from "./exchange-rate-afir-results.pug?vue&type=template&id=28a2b5a8&scoped=true&lang=pug&external"
import script from "./exchange-rate-afir-results.js?vue&type=script&lang=js&external"
export * from "./exchange-rate-afir-results.js?vue&type=script&lang=js&external"
import style0 from "./exchange-rate-afir-results.scss?vue&type=style&index=0&id=28a2b5a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a2b5a8",
  null
  
)

export default component.exports